import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

// import { iconTicket } from '../../../assets/icons';
import { getImageUrl, navigate } from '../../../helpers';
import { getSplashEventList } from '../../../ducks/events';
import BackgroundImage from '../components/BackgroundImage';
import Content from '../components/Content';
import Empty from '../components/Empty';
import Header from '../components/Header';
import Loader from '../components/Loader';
import dhLogo from '../../../assets/logos/onBlack@2x.png';
import styles from './events.scss';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  events: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })),
  error: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

class Events extends React.PureComponent {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getSplashEventList());
  }

  render() {
    const {
      events,
      loading,
      dispatch,
      error,
      history,
    } = this.props;

    const sortedEvents = events.slice().sort((a, b) => (
      moment(a.start).diff(b.start)
    ));

    const upcomingEvents = sortedEvents.filter((event) => (
      moment(event.end).isSameOrAfter(moment().startOf('day'))
      && event.app_published
    ));

    return (
      <>
        <Header
          showUser
          history={history}
        >
          <img
            src={dhLogo}
            alt="DreamHack"
            className={styles.headerLogo}
          />
        </Header>
        <Content>
          <div className={styles.body}>
            <Loader loading={loading} />
            <Empty
              empty={!loading && !upcomingEvents?.length}
              title="There are no upcoming events."
              message={'We haven\'t released any new events yet. Come back later to see our upcoming events!'}
              error={error}
              onReload={() => dispatch(getSplashEventList())}
            />
            { upcomingEvents?.length > 0
              && (
                <div className={styles.events}>
                  { upcomingEvents.map((event) => (
                    <BackgroundImage
                      key={event.shortcode}
                      src={getImageUrl(event.image_id)}
                      className={styles.event}
                      onClick={() => navigate(history, `/app/event/${event.shortcode}`)}
                    >
                      <div className={styles.text}>
                        { event.purchase_url
                          && (
                          <div className={styles.tickets}>
                            Tickets out now
                          </div>
                          )}
                        <div className={styles.name}>
                          {event.name}
                        </div>
                        <div className={styles.location}>
                          {moment(event.start).format('D MMM')}
                          {' '}
                          –
                          {moment(event.end).format('D MMM')}
                        </div>
                      </div>
                      <div className={styles.tint} />
                    </BackgroundImage>
                  ))}
                </div>
              )}
          </div>
        </Content>
      </>
    );
  }
}

Events.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    events: state.getIn(['events', 'events']),
    loading: state.getIn(['events', 'loading']),
    error: state.getIn(['events', 'error']),
    loaded: state.getIn(['events', 'loaded']),
  };
}

export default connect(mapStateToProps)(Events);
